/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { APIEnum } from '../../../modules/loadbalancer/shared/enums/api';
import { Injectable } from '@angular/core';
import { environment, ModulesEnum } from '../../../../environments/environment';

@Injectable()
export class ConnectionDetailsService {
    get environment(): any {
        return environment;
    }

    /**
     * Get the Modules ENUM, so we can use it in the view.
     */
    get modulesEnum(): any {
        return ModulesEnum;
    }

    /**
     * Returns the connection history details
     * @returns {string | null}
     */
    public getConnHistLocalStorage(): any {
        const connectionHistory = JSON.parse(localStorage.getItem('lbHistory')) || {};

        if (!connectionHistory.ip) {
            connectionHistory.ip = window.location.hostname;
        }

        if (!connectionHistory.port) {
            connectionHistory.port = parseInt(window.location.port, 10) || 443;
        }

        return connectionHistory;
    }

    /**
     * Get connection url.
     */
    public getUrl(): string {
        const connectionHistory = this.getConnHistLocalStorage();

        if (this.isLoadbalancer()) {
            return `https://${connectionHistory.ip}/api/${APIEnum.POST_VERSION}`;
        }

        let applianceAddress: string = 'portal.loadbalancer.org';
        if (!environment.production) {
            applianceAddress = connectionHistory.ip;
        }

        return `https://${applianceAddress}/api/${APIEnum.POST_VERSION}`;
    }

    /**
     * Get connection address.
     */
    public getAddress(): string {
        const connectionHistory = this.getConnHistLocalStorage();

        if (this.isLoadbalancer()) {
            return connectionHistory.ip;
        }

        let applianceAddress: string = 'portal.loadbalancer.org';
        if (!environment.production) {
            const connectionHistory = this.getConnHistLocalStorage();
            applianceAddress = connectionHistory?.ip ? connectionHistory.ip : 'kodiak.lborg.dev';
        }

        return applianceAddress;
    }

    /**
     * Get connection port.
     */
    public getPort(): number {
        const connectionHistory = this.getConnHistLocalStorage();

        return connectionHistory.port;
    }

    /**
     * Check if we are a loadbalancer or not.
     */
    public isLoadbalancer(): boolean {
        return this.environment.module === this.modulesEnum.LOADBALANCER;
    }

    /**
     * Check if we are Portal or not.
     */
    public isPortal(): boolean {
        return this.environment.module === this.modulesEnum.CENTRALISED_MANAGEMENT;
    }
}
